export function toDate(utcDate: Date): Date {
  const convertToLocalDate = new Date();
  convertToLocalDate.setUTCDate(utcDate.getDate());
  convertToLocalDate.setUTCHours(utcDate.getHours());
  convertToLocalDate.setUTCMinutes(utcDate.getMinutes());
  return convertToLocalDate;
}

export function toLocalDateString(utcDate: Date): string {
  if (!utcDate) {
    return "";
  }
  const convertToLocalDate = new Date(utcDate);
  return (
      convertToLocalDate.getDate().toString().padStart(2, "0") +
      "." +
      (convertToLocalDate.getMonth() + 1).toString().padStart(2, "0") +
      "." +
      convertToLocalDate.getFullYear());
}

export function toLocalDateTimeString(date: Date): string {
  if (!date) {
    return "";
  }
  const convertToLocalDate = new Date(date);
  return (
    convertToLocalDate.getDate().toString().padStart(2, "0") +
    "." +
    (convertToLocalDate.getMonth() + 1).toString().padStart(2, "0") +
    "." +
    convertToLocalDate.getFullYear() +
    " " +
    convertToLocalDate.getHours().toString().padStart(2, "0") +
    ":" +
    convertToLocalDate.getMinutes().toString().padStart(2, "0")
  );
}

export function toDateTimeString(utcDate: Date): string {
  const convertToDate = utcDate;
  return (
    convertToDate.getFullYear() +
    "-" +
    (convertToDate.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    convertToDate.getDate().toString().padStart(2, "0") +
    " " +
    convertToDate.getHours().toString().padStart(2, "0") +
    ":" +
    convertToDate.getMinutes().toString().padStart(2, "0")
  );
}

export function isDateNowOverdue(utcDate: Date): boolean {
  const convertToLocalDate = utcDate;
  return convertToLocalDate < new Date();
}
